import { type Context, createContext } from 'react';

import { type ActionPayloadMap } from './types.interface';

export type EventPack = [
  <T extends keyof ActionPayloadMap>(event: T, cb: (payload: ActionPayloadMap[T]) => Promise<void> | void) => void, // subscribe
  <T extends keyof ActionPayloadMap>(event: T, cb: (payload: ActionPayloadMap[T]) => Promise<void> | void) => void, // unsubscribe
  <T extends keyof ActionPayloadMap>(event: T, payload: ActionPayloadMap[T]) => void, // dispatch
];

const EventContext: Context<EventPack> = createContext<EventPack>([
  () => {}, // subscribe
  () => {}, // unsubscribe
  () => {}, // dispatch
]);

export default EventContext;
